/*
 * $Id:: utils.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Typography from '@material-ui/core/Typography';

import { ReactComponent as ArrowRightIcon } from '../../assets/images/arrow_right_24px.svg';
import { ReactComponent as SelectedItemArrow } from '../../assets/images/selected_item.svg';
import { t } from '../../providers';

export const viewableItems = ({ items, navigateTo, userType, authorities, rootPath, sidebarType, classes, location }) => {
    const findAuthSubmenu = (submenu = []) =>
        submenu.find((sm) => sm.path.startsWith(rootPath) || (sm.includeParam && sm.path === location.pathname));
    const findUnAuthSubmenu = (submenu = []) => submenu.find((sm) => sm.path === rootPath || (sm.includeParam && sm.path === location.pathname));

    return items
        .filter(({ cannotAccess }) => !cannotAccess || !cannotAccess(userType, authorities))
        .map(({ key, value, path, query, submenu = [], Icon }) => {
            let selectedSubmenu = null;
            let isSelected = rootPath === path; // unauthorized user OR  authorized user with rootPath: '/'
            if (sidebarType === 'auth' && rootPath !== '/') {
                // authorized user
                isSelected = path && path.startsWith(rootPath);

                if (!isSelected) {
                    isSelected = !!submenu.length && findAuthSubmenu(submenu);
                }
            }

            if (!isSelected) {
                selectedSubmenu = !!submenu.length && findUnAuthSubmenu(submenu);
            }

            const selectedClass = (isSelected && ` ${classes.selectedOption}`) || '';
            const optionClass = `${classes.cursorPointer}${selectedClass}`;

            return (
                <div key={key} className={classes.sidebarOption}>
                    <div className={classes.option} onClick={(e) => navigateTo(e, !!query ? path + query : path)}>
                        <div>
                            {(isSelected || !!selectedSubmenu) && (
                                <div className={classes.sidebarOptionIcon}>
                                    <SelectedItemArrow className={[!!selectedSubmenu && classes.notSelectedArrow].join(' ')} />
                                </div>
                            )}
                            <Typography className={`${optionClass} ${classes.sidebarOptionTitle}`}>{t(value)}</Typography>
                        </div>

                        {Icon && <Icon id={value.toLowerCase().replaceAll('.', '-')} />}
                    </div>

                    {!!selectedSubmenu && (
                        <div className={classes.submenuOption}>
                            <ArrowRightIcon className={classes.rightArrowIcon} />
                            <Typography variant="subtitle2" className={`${classes.selectedSubmenuOption}`}>
                                {t(selectedSubmenu.value)}
                            </Typography>
                        </div>
                    )}
                </div>
            );
        });
};
